// 订单列表 tab栏 功能枚举
export enum ETabType {
  // 全部订单
  All = 1,
  // 未完结急单
  Unfinished = 2,
  // 遗漏订单
  Omit = 3,
  // 待审核
  Audit = 4,
  // 满员
  Full = 5,
  // 退订失败
  UnsubscribeFailure = 6,
  // 异常订单
  Abnormal = 7,
  // 占位订单
  Occupied = 8,
  // 待二次确认
  ConfirmedAgain = 9,
  // 过期未确认
  OverdueUnconfirmed = 10,
  // 过期尾款未付未退
  OBPaymentUnpaid = 11,
  // 待二次检查
  Recheck = 12,
  // 日期重叠检查
  DateOverlapCheck = 13
}

// 订单列表 tab栏功能
export const OrderListTabInfo = [
  {
    name: "全部订单",
    value: ETabType.All
  },
  {
    name: "未完结加急",
    value: ETabType.Unfinished
  },
  {
    name: "遗漏",
    value: ETabType.Omit
  },
  {
    name: "待审核",
    value: ETabType.Audit
  },
  {
    name: "满员",
    value: ETabType.Full
  },
  {
    name: "退订失败",
    value: ETabType.UnsubscribeFailure
  },
  {
    name: "异常",
    value: ETabType.Abnormal
  },
  {
    name: "占位",
    value: ETabType.Occupied
  },
  {
    name: "待二次确认",
    value: ETabType.ConfirmedAgain
  },
  {
    name: "过期未确认",
    value: ETabType.OverdueUnconfirmed
  },
  {
    name: "过期尾款未付未退",
    value: ETabType.OBPaymentUnpaid
  },
  {
    name: "待二次检查",
    value: ETabType.Recheck
  },
  {
    name: "日期重叠检查",
    value: ETabType.DateOverlapCheck
  }
];

// 历史订单列表
export enum EHistoryType {
  No = 0,
  Yes = 1
}
